import { Navigate, useLocation } from "react-router";

// Keep bookmarks to removed overviews working, including query parameters and fragments.
export function OverviewRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
